import { render, staticRenderFns } from "./football.vue?vue&type=template&id=9510ecb8&scoped=true&"
import script from "./football.vue?vue&type=script&lang=js&"
export * from "./football.vue?vue&type=script&lang=js&"
import style0 from "./football.vue?vue&type=style&index=0&id=9510ecb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9510ecb8",
  null
  
)

export default component.exports